import Api from "@/helpers/api.js";

export default {
	addTeam({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.post("/team", item)
				.then((response) => {
					commit("ADD_TEAMS", Object.assign(item, {id: response.data.id}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchDataListItems({commit, dispatch}) {
		return new Promise((resolve, reject) => {
			Api.get("/team")
				.then((res) => {
					commit("SET_TEAMS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	getTeamById({commit, dispatch}, item) {
		return new Promise((resolve, reject) => {
			Api.get(`/team/${item.id}`)
				.then((res) => {
					commit("ADD_ASSIGNED_LIST_TEAMS", [res.data]);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	updateItem({commit}, item) {
		return new Promise((resolve, reject) => {
			Api.put(`/team/${item.id}`, item)
				.then((response) => {
					// commit('UPDATE_TEAM', response.data)
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeItem({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/team/${itemId}`)
				.then((response) => {
					commit("REMOVE_TEAM", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
